import React from 'react'

const BannerCard: React.FC = () => {
  const bannerUrl = 'https://s.vistori.as/assets/mid_ladobom.png'

  const handleClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <div
      onClick={() => handleClick('https://www.ladobom.com/')}
      className="mb-8 mt-4 flex cursor-pointer flex-col items-center rounded-xl md:flex-1"
    >
      <img src={bannerUrl} className="max-w-[390px]" />
    </div>
  )
}

export default BannerCard
